import { useState, useEffect } from 'react'
import cn from 'clsx'

// Utils
import { WIDTH, HEIGHT } from 'components/kit/waveform/constants'

import styles from './wave.css'

type WaveProps = {
  points: Array<string>
  playedRatio: number
  trackId: number
  isActive?: boolean
  isHovered?: boolean
}

const Wave = ({ points, isActive, isHovered, playedRatio, trackId }: WaveProps): JSX.Element => {
  const [clipPathId, setClipPathId] = useState('')
  const classNames = cn(isActive ? styles.waveFormIsActive : styles.waveForm, isHovered && styles.isHovered)

  useEffect(() => {
    setClipPathId(`progress-clip-path-${trackId}-${Math.random()}`)
  }, [trackId])

  const playedValue = (playedRatio * WIDTH).toFixed(1)

  return (
    <>
      <clipPath id={clipPathId}>
        <rect x="0" y="0" width={playedValue} height={HEIGHT} />
      </clipPath>
      <polygon points={points} className={classNames} />
      {isActive && (
        <>
          <polygon points={points} className={cn(classNames, styles.waveFormPlayed)} clipPath={`url(#${clipPathId})`} />
          <line x1={playedValue} y1="1" x2={playedValue} y2={HEIGHT} className={styles.indicator} />
        </>
      )}
    </>
  )
}

export default Wave
